/* eslint-disable */
import React from "react";
import { Skeleton } from "antd";
import { useSelector } from "react-redux";
import VisitShareButton from "./sidebar/VisitShareButton";
import { useTranslation } from "react-i18next";

const ProfileCard = ({
  data,
  data2,
  account,
  worker,
  isRtl,
  domain,
  isWorker = false,
}) => {
  const isLoading = !data || !data2;
  const digitalStore = useSelector((state) => state.digitalStoreReducer);

  const { t } = useTranslation();

  const skeletonStyle = {
    backgroundColor: "#53286a",
    opacity: 0.1,
  };

  const getLogoSrc = () => {
    // 1) Worker: always use worker photo
    if (isWorker) {
      return worker?.photoUrl || "https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk3sJTTVkx1I8VlUWNceyu9XYaJZTiR2sdjD5S";
    }

    // 2) Owner: use store logo depending on productMode
    const productMode = account?.productMode ?? "classic";

    if (productMode === "classic") {
      return data2?.logo || "https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk3sJTTVkx1I8VlUWNceyu9XYaJZTiR2sdjD5S";
    } else if (productMode === "product") {
      return data2?.img || "https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk3sJTTVkx1I8VlUWNceyu9XYaJZTiR2sdjD5S";
    } else {
      return digitalStore?.logo || "https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk3sJTTVkx1I8VlUWNceyu9XYaJZTiR2sdjD5S";
    }
  };

  const roleTranslationMap = {
    confirmer: "sidebar.roles.confirmer",
    partner: "sidebar.roles.partner",
  };

  const getBadgeContent = () => {
    if (isWorker && worker) {
      const role = worker.role || "";
      const translationKey = roleTranslationMap[role.toLowerCase()];
      return translationKey ? t(translationKey) : role;
    } else if (account) {
      const isFreeCountry = account.isFreeCountry || false;
      if (isFreeCountry) {
        return t("navbar.avatarMenu.free");
      }

      const planKeyMap = {
        الأساسية: "basic",
        الاساسية: "basic",
        basic: "basic",
        المتطورة: "advanced",
        advanced: "advanced",
        الأسطورية: "legendary",
        الاسطورية: "legendary",
        legendary: "legendary",
      };

      const planKey = planKeyMap[account?.subscription?.plan];
      return planKey
        ? t(`subscription.plans.${planKey}`)
        : account?.subscription?.plan;
    }
    return "";
  };

  const getDisplayName = () => {
    if (isWorker) {
      return worker?.name || t("sidebar.team");
    }
    return data?.name || "";
  };

  return (
    <div className="p-0 d-flex gap-3 p-sm-2 mr-3" style={{ minWidth: 0 }}>
      <div
        className="justify-content-center rounded relative my-auto"
        style={{ width: 65, height: 65, flexShrink: 0 }}
      >
        {/* Le badge */}
        {isLoading ? (
          <Skeleton.Button
            active
            size="small"
            style={{
              ...skeletonStyle,
              position: "absolute",
              bottom: "-5px",
              left: "50%",
              transform: "translateX(-50%)",
              borderRadius: "12px",
              width: 60,
              height: 20,
            }}
          />
        ) : (
          <span
            title={getBadgeContent() || undefined}
            className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-[7px] bg-[#f9c02e] text-black rounded-xl px-2 py-1 text-xs"
            style={{
              zIndex: 1,
              maxWidth: 90,
              width: "max-content",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              lineHeight: "16px",
            }}
          >
            {getBadgeContent()}
          </span>
        )}
        <img
          src={getLogoSrc()}
          width={65}
          height={65}
          alt={t("ui.profile")}
          className="rounded-[33%] border-2 border-[#f9c02e] border-dashed bg-white"
          style={{ width: 65, height: 65, objectFit: "cover", display: "block" }}
        />
      </div>
      <div
        className="d-flex flex-column align-items-center justify-content-center text-white text-center"
        style={{ minWidth: 0, flex: 1 }}
      >
        {/* Le nom ou "Team" */}
        {isLoading ? (
          <Skeleton.Input
            active
            size="small"
            style={{
              ...skeletonStyle,
              width: 100,
              margin: "8px 0",
            }}
          />
        ) : (
          <p
            className="my-2 d-none d-sm-inline text-xl"
            title={getDisplayName()}
            style={{ maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {getDisplayName()}
          </p>
        )}
        {/* Le bouton */}
        {isLoading ? (
          <Skeleton.Button
            active
            style={{
              ...skeletonStyle,
              width: 80,
              height: 30,
              marginTop: 8,
            }}
          />
        ) : isWorker ? null : (
          <VisitShareButton
            link={
              (account?.productMode ?? "classic") !== "digital"
                ? account?.store
                : domain
            }
            isRTL={isRtl}
          />
        )}
      </div>
    </div>
  );
};

export default ProfileCard;
